export default "__VITE_ASSET__udAtsToj__"